<ng-container *transloco="let t" class="container">
  <form [formGroup]="inputForm">
    <app-admin-modal-layout
            [title]="'administrator.discounts.management.discountItem.add.title'"
            [saveLabel]="'app.common.confirm'"
            (onSave)="onConfirmClick()"
            (onClose)="activeModal.dismiss('Cross click')"
            [saveDisabled]="!inputForm.valid || !inputForm.touched"
            [showCancel]="false">


      <app-input formControlName="numberOfRaces"
                 label="administrator.discounts.management.discountItem.add.numberOfRaces"/>
      <div class="pt-3">
        <app-input formControlName="amount"
                   label="administrator.discounts.management.discountItem.add.amount"/>
      </div>

    </app-admin-modal-layout>
  </form>
</ng-container>

